import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, filter, map, switchMap, takeUntil } from 'rxjs/operators'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'

import { CUSTOM_TIMEFRAME } from 'components/pages/settings/atoOverview/constants'

import { CUSTOM_RANGE_CHANGE, FETCH_ATO_OVERVIEW_ASYNC, TIMEFRAME_CHANGE } from './constants'

// A half-picked custom range has nothing to fetch yet.
const isReady = ({ timeframe, customRange }) =>
  timeframe !== CUSTOM_TIMEFRAME || Boolean(customRange?.from && customRange?.to)

const fetchOverviewEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(
      FETCH_ATO_OVERVIEW_ASYNC.INITIATE,
      TIMEFRAME_CHANGE,
      CUSTOM_RANGE_CHANGE,
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS
    ),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS) {
        return matchURL(URL_CONST.dashboard.ato)
      }
      return true
    }),
    filter(() => isReady(state$.value.dashboard.atoOverview.self)),
    // switchMap: a quick second timeframe click drops the first response.
    switchMap(() => {
      const { timeframe, customRange } = state$.value.dashboard.atoOverview.self
      return api.atoOverview
        .getOverview(
          { timeframe, from: customRange?.from, to: customRange?.to },
          state$.value.partnerOptions.selectedCompany?.value
        )
        .pipe(
          map((response) => FETCH_ATO_OVERVIEW_ASYNC.onSuccess(response)),
          catchError((error) => of(epicsErrorHandler(FETCH_ATO_OVERVIEW_ASYNC.onError, error))),
          takeUntil(action$.pipe(ofType(FETCH_ATO_OVERVIEW_ASYNC.CANCEL)))
        )
    })
  )

export default combineEpics(fetchOverviewEpic)
